import {ValueObject} from '@s-ui/domain'

export class UserEmailExistsValueObject extends ValueObject {
  #exists

  constructor({exists}) {
    super()
    this.#exists = exists
  }

  static create({exists}) {
    return new UserEmailExistsValueObject({exists})
  }

  getExists() {
    return this.#exists
  }

  toJSON() {
    return {
      exists: this.#exists
    }
  }
}
